import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms'

export class Validators {
    static equalsTo(controlToCompare: AbstractControl): ValidatorFn {
        return (control: AbstractControl): ValidationErrors => {
            if (
                isEmptyInputValue(control.value) ||
                isEmptyInputValue(controlToCompare.value) ||
                control.value === controlToCompare.value
            ) {
                return null
            }

            return {
                equalsTo: {
                    equalsTo: controlToCompare.value,
                    actual: control.value
                }
            }
        }
    }

    // static maxDate(maxDate: Date): ValidatorFn {
    //     return (control: AbstractControl): ValidationErrors => {
    //         let date: Date

    //         if (control.value instanceof Date) {
    //             date = control.value
    //         }

    //         const invalid = date > maxDate

    //         if (invalid) {
    //             return {
    //                 maxDate: {
    //                     value: control.value
    //                 }
    //             }
    //         }

    //         return null
    //     }
    // }
}

function isEmptyInputValue(value: any) {
    return value == null || value.length === 0
}



// WEBPACK FOOTER //
// ./src/app/common/validators.ts